module.exports = __webpack_public_path__ + "img/img_product_FGF_4.19b204c4.jpg";